import React from "react";

import moment from "moment";

import Select from "react-select";

import Slider, { Range } from "rc-slider";

import { Button, ButtonGroup, Dropdown, Accordion } from "aible";
import { Popover, OverlayTrigger, Modal } from "react-bootstrap";
import Toggle from "react-toggle";

import { isEnabled } from "utils/featureFlags";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCog,
  faChevronLeft,
  faThumbsUp,
  faThumbsDown,
  faTrash,
  faEdit,
  faArrowAltCircleUp,
  faArrowAltCircleDown,
  faExclamationTriangle
} from "@fortawesome/free-solid-svg-icons";

import NumericLabel from "react-pretty-numbers";

import { LineInput } from "components/Inputs/LineInput";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import Waterfall from "components/Waterfall/Waterfall";

import ImpactSlider from "components/Optimizer/ImpactSlider";
import CostsWaterfall from "components/Costs/Waterfall/CostsWaterfall";

import ProjectTitle from "components/UnifiedProject/ProjectTitle";
import ProjectHelpContainer from "containers/UnifiedProject/Help/ProjectHelp";
import ProjectHelpItem from "components/UnifiedProject/Help/ProjectHelpItem";

import ModelBoxContainer from "containers/Business/ModelBox/ModelBox";

import CurrentStateContainer from "containers/CurrentState/CurrentState";
import { AIBLE_VIEW_TYPE, isSameSetup } from "containers/Project/reducer";

import { checkValueWarning, getWarningMessage } from "containers/Setup/reducer";

import numeral from "numeral";

import RefreshIcon from "images/refreshB.svg";
import PurpleMind from "images/PurpleMind.svg";
import PurpleTarget from "images/PurpleTarget.svg";
import PurpleWarning from "images/PurpleWarning.svg";

import styles from "./style.module.css";

export const PROJECT_MODES = {
  OVERALL: "Overall",
  DRILLDOWN: "Drilldown",
  VIEW_SEGMENTS: "View Subgroups"
};

const numberFormatParams = {
  shortFormat: true,
  shortFormatMinValue: 0,
  precision: 1,
  justification: "L",
  locales: "en-US"
};

export default class RealityCheck extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = { countType: "SOME" };
  }

  getLabelFromSegment(segment) {
    return segment.conditions.length === 0 ? "Overall" : segment.conditions[0].value;
  }

  renderHelp() {
    const {} = this.props;
    return (
      <ProjectHelpContainer title={"Validate Expected Behavior"} subtitle={"Why are we asking these questions?"}>
        <ProjectHelpItem type={"mind"}>
          {"Adding business terms improves the clarity " + "of the insights, predictions and recommendations."}
        </ProjectHelpItem>
        <ProjectHelpItem type={"target"}>
          {"Validating the behavior ensures that " + "the AI is trained on an expected reality."}
        </ProjectHelpItem>
        <ProjectHelpItem type={"warning"}>
          {"If the data doesnt reflect reality, which is a common problem in AI tools, " +
            "the AI will attempt to optimize for an incorrect goal."}
        </ProjectHelpItem>
      </ProjectHelpContainer>
    );
  }

  render() {
    const {
      setup,
      madLibs,
      setupLabels,
      updateMadLibs,
      updateTransactionLabel,
      updateUnitType,
      updateConversionGain,
      updateConversionCost,
      updateContinuousCount,
      updateContinuousAveragePrice,
      updateContinuousPercent,
      updateExpectedCountContinuous,
      updateExpectedValueContinuous,
      updateCurrentProfit,
      transactionLabel,
      outcomeLabel,
      notPursuedTransactionLabel,
      trueAction,
      falseAction,
      unitType,
      isOverallSegment
    } = this.props;

    const dateOptions = [
      { label: "Month", value: "Month" },
      { label: "Day", value: "Day" },
      { label: "Week", value: "Week" },
      { label: "Year", value: "Year" }
    ];

    return (
      <div className={styles.realityHolder}>
        <div className={styles.realityMid}>
          <div className={styles.smallTitle} style={{ marginBottom: "0px" }}>
            {"AI Optimized For Your Business"}
          </div>
          <div className={styles.secondTitle} style={{ marginTop: "40px" }}>
            {"How many transactions do you process every month?"}
          </div>
          <div className={styles.rcFlex}>
            <div style={{ marginRight: "5px" }}>{"On average I process "}</div>
            <LineInput
              isMediumBox
              value={setup ? setup.expectedCountContinuous : undefined}
              onChange={(val) => val !== "" && updateExpectedCountContinuous(val)}
            />
            <div style={{ marginRight: "5px", marginLeft: "-10px" }}>
              <strong>{setupLabels.transactionLabel}</strong>
              {" per "}
            </div>
            <div style={{ width: "150px" }}>
              <Select options={dateOptions} defaultValue={dateOptions[0]} />
            </div>
          </div>
          <div className={styles.secondTitle} style={{ marginTop: "40px" }}>
            {"What are the average costs and benefits for your "}
            <strong>{setupLabels.transactionLabel}</strong>
            {"?"}
          </div>

          <div className={styles.cImpacts}>
            <div className={styles.cImpact}>
              <div className={styles.cImpactLabel}>
                {"Average "}
                <strong>{setupLabels.numberPredicted}</strong>
              </div>
              <div className={styles.cImpactInput}>
                <LineInput
                  isMediumBox
                  value={setup ? setup.expectedValueContinuous : undefined}
                  onChange={(val) => val !== "" && updateExpectedValueContinuous(val)}
                />
              </div>
            </div>
            <div className={styles.cImpact}>
              <div className={styles.cImpactLabel}>
                {"Best Case "}
                <strong>{setupLabels.profitLabel}</strong>
              </div>
              <div className={styles.cImpactInput}>
                <LineInput
                  isMediumBox
                  value={setup ? setup.continuousPercent : undefined}
                  onChange={(val) => updateContinuousPercent(val)}
                />
              </div>
            </div>
            <div className={styles.cImpact}>
              <div className={styles.cImpactLabel}>
                <strong>{setupLabels.overPredictAction}</strong>
              </div>
              <div className={styles.cImpactInput}>
                <LineInput
                  isMediumBox
                  value={setup ? setup.conversionGain : undefined}
                  onChange={(val) => updateConversionGain(val)}
                />
              </div>
            </div>
            <div className={styles.cImpact}>
              <div className={styles.cImpactLabel}>
                <strong>{setupLabels.underPredictAction}</strong>
              </div>
              <div className={styles.cImpactInput}>
                <LineInput
                  isMediumBox
                  value={setup ? setup.conversionCost : undefined}
                  onChange={(val) => updateConversionCost(val)}
                />
              </div>
            </div>
            <div className={styles.cImpact}>
              <div className={styles.cImpactLabel}>
                {"Current Total "}
                <strong>{setupLabels.profitLabel}</strong>
              </div>
              <div className={styles.cImpactInput}>
                <LineInput
                  isMediumBox
                  value={setup ? setup.currentProfit : undefined}
                  onChange={(val) => updateCurrentProfit(val)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
